import createStoreService from '@/store/init'

export default defineNuxtPlugin((nuxtApp) => {
  const store = createStoreService()
  nuxtApp.vueApp.use(store)
})
